import Transaction from 'src/app/core/models/Transaction'

export const tabs = [
  {
    tab: 'folder',
    icon: 'folder',
    text: 'Φάκελος',
  },
  {
    tab: 'customer',
    icon: 'id-card',
    text: 'Στοιχεία Νομικού<br>Προσώπου',
    longText: 'Στοιχεία Νομικού Προσώπου',
  },
  {
    tab: 'members',
    icon: 'users',
    text: 'Μέλη Δ.Σ. (επί Α.Ε.),<br>Εταίροι (επί ΟΕ, ΕΕ, ΕΠΕ)<br>κ.ο.κ.',
    longText: 'Μέλη Δ.Σ. (επί Α.Ε.), Εταίροι (επί ΟΕ, ΕΕ, ΕΠΕ) κ.ο.κ.',
  },
  {
    tab: 'representatives',
    icon: 'briefcase',
    text: 'Εκπρόσωποι',
  },
  {
    tab: 'owners',
    icon: 'user-tie',
    text: 'Στοιχεία Πραγματικού<br>Δικαιούχου (B/O)',
    longText: 'Στοιχεία Πραγματικού Δικαιούχου (B/O)',
  },
  {
    tab: 'documents',
    icon: 'file',
    text: 'Έγγραφα',
  },
  {
    tab: 'comments',
    icon: 'comment',
    text: 'Παρατηρήσεις',
  },
]

export const actions = [
  //{
  //   icon: 'save',
  //   text: 'Προσωρινή Αποθήκευση',
  //   func: 'save'
  // },
  {
    icon: 'file-pdf',
    text: 'Προεπισκόπηση<br>Αποθηκευμένων Στοιχείων',
    longText: 'Προεπισκόπηση Αποθηκευμένων Στοιχείων',
    func: 'preview',
  },
  {
    icon: 'clipboard-check',
    text: 'Ολοκλήρωση',
    func: 'complete',
  },
  {
    icon: 'undo',
    text: 'Reset',
    func: 'reset',
  },
  {
    icon: 'cloud-upload-alt',
    text: 'Άλλος Τύπος Γνωμάτευσης',
    func: 'upload',
  },
]
